import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridCellParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
// import { deleteOcspConfiguration } from '../../../store/feature/satpasDevice';
import PaginationControl from "../pagination/Pagination";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import {
  useEksportKeyDsaMutation,
  useEksportKeyRsaMutation,
} from "../../../store/feature/service/importKeyApiSlice";
import { useDeleteDACertMutation } from "../../../store/feature/service/domainAuthorCertApiSlice";

const DomainAuthorCertTable = ({
  data,
  params,
  setParams,
  defaultValue,
  setDefaultValue,
}: any) => {
  // REGION: INIT VARIABLES
  const navigate = useNavigate();
  const [pemName, setPemName] = useState("");
  const { domainAuthCert } = useAppSelector((state: RootState) => state.role);
  const [deleteKey, { isSuccess, isError }] = useDeleteDACertMutation();

  const [
    eksportDsa,
    {
      isSuccess: successDsa,
      isError: isErrorDsa,
      data: dataDsa,
      error: errorDsa,
    },
  ] = useEksportKeyDsaMutation();
  const [
    eksportRsa,
    {
      isSuccess: successRsa,
      isError: isErrorRsa,
      data: dataRsa,
      error: errorRsa,
    },
  ] = useEksportKeyRsaMutation();

  // REGION: RENDER BUTTON CELL
  const customCellRender = (params: GridCellParams) => {
    // REGION: NAVIGATE TO EDIT
    const onEdit = (e: any) => {
      e.stopPropagation(); // don't select this row after clicking
      navigate(`/domain-authority-certificate/edit/${params.row.uid}`);
    };

    // REGION: DISPATCH DELETE DATA
    const onDelete = (e: any) => {
      e.stopPropagation(); // don't select this row after clicking
      Swal.fire({
        title: "Delete Confirmation",
        text: "Are you sure delete this configuration? You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#808080",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteKey(params.row.uid);
        }
      });
    };

    const onExport = (e: any) => {
      e.stopPropagation(); // don't select this row after clicking
      if (params.row.keyType === "RSA") {
        eksportRsa({ kid: params.row.kid });
        const arrName = params.row.kid.split("/");
        setPemName(arrName[arrName.length - 1]);
        console.log("rusak RSA ==> ", arrName);
      } else {
        eksportDsa({ kid: params.row.kid });
        const arrName = params.row.kid.split("/");
        setPemName(arrName[arrName.length - 1]);
      }
    };

    // REGION: RETURN TSX
    return (
      <>
        <Stack spacing={2} direction="row">
          {params.row.keyType === "RSA" || params.row.keyType === "ECDSA" ? (
            <Button variant="contained" onClick={onExport}>
              Export
            </Button>
          ) : null}
          {domainAuthCert.update && (
            <Button variant="contained" onClick={onEdit}>
              Update
            </Button>
          )}
          {domainAuthCert.delete && (
            <Button variant="contained" color="error" onClick={onDelete}>
              Delete
            </Button>
          )}
        </Stack>
      </>
    );
  };

  // REGION: INIT COLUMNS
  const columns: GridColDef[] = [
    {
      field: "daCertName",
      headerName: "DAID Name",
      flex: 1,
      minWidth: 250,
      headerClassName: "centered",
    },
    {
      field: "daCertCommonName",
      headerName: "DA Certificate Common Name",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "inputtedAt",
      headerName: "Inputted at",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => {
        if (params.row.status !== null) {
          switch (params.row.status.toLowerCase()) {
            case "active": {
              return <Chip label="Active" color="success" variant="outlined" />;
            }
            case "inactive": {
              return (
                <Chip label="Inactive" color="warning" variant="outlined" />
              );
            }
          }
        } else {
          return "";
        }
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 320,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: customCellRender,
    },
  ];

  useEffect(() => {
    if (isSuccess) {
      Swal.fire({
        icon: "success",
        title: "Success Delete",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Success Delete Domain Authority Certificate",
      });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      Swal.fire({
        icon: "error",
        title: "Error Delete",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Error Delete Domain Authority Certificate",
      });
    }
  }, [isError]);
  // REGION: INIT ROWS
  console.log("data form table ===> ", data?.data);
  const dataRows =
    data?.data !== null && data?.data !== undefined ? data?.data : [];
  const rows = dataRows.map((row: any, index: any) => ({
    // uid: row.uc_ocsp_config_uid,
    id: index,
    uid: row.dsg_da_root_certificate_uid,
    daCertName: row.dsg_da_root_certificate_daid,
    daCertCommonName: row.dsg_da_root_certificate_cn,
    inputtedAt: row.dsg_da_root_certificate_inputted_at,
    status: row.dsg_da_root_certificate_status,
  }));

  // REGION: RETURN TSX
  return (
    <>
      <Box sx={{ height: "650px" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnMenu
          hideFooter
          disableColumnSelector
          disableDensitySelector
          disableSelectionOnClick
        />
      </Box>
      <PaginationControl
        params={params}
        setParams={setParams}
        total={data.total_records}
      />
    </>
  );
};

export default DomainAuthorCertTable;
